import React from "react";
import PropTypes from "prop-types";

import ErrorThrower from "components/Library/ErrorThrower";
import { APOLLO_NETWORK_STATUS } from "config/constants.js";

/*
 * Handles GraphQL and network errors in a stream. 
 * Sets a 404 error for GraphQL errors. 
 * Sets a 500 for network errors. (ie. Charon isn't responding)
 */
export default function StreamErrorWrapper({ error, networkStatus, children }) {
  if (error) {
    return <ErrorThrower status={404} error={error} />;
  } else if (networkStatus === APOLLO_NETWORK_STATUS.ERROR) {
    return <ErrorThrower status={500} />;
  }

  return children;
}

StreamErrorWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  error: PropTypes.instanceOf(Error),
  networkStatus: PropTypes.oneOf(Object.values(APOLLO_NETWORK_STATUS)),
};
